export default __webpack_public_path__ + "static/media/img-0790-portugal-premium-face.f46d63b8.png";